module.exports = new __parcel__URL__("classic-report-app-skeleton.tpl.1daae66d.svg").toString();